import styled from 'styled-components';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

interface $StepsOrchestratorAnimationProps {
  $parentPadding: number;
}

export const $StepsOrchestratorAnimation = styled.div<$StepsOrchestratorAnimationProps>`
  padding-left: ${({ $parentPadding }) => rem($parentPadding)};
  padding-right: ${({ $parentPadding }) => rem($parentPadding)};
`;

interface $StepsOrchestratorContainerProps {
  $parentPadding: number;
}

export const $StepsOrchestratorContainer = styled.div<$StepsOrchestratorContainerProps>`
  position: relative;
  margin-left: -${({ $parentPadding }) => rem($parentPadding)};
  margin-right: -${({ $parentPadding }) => rem($parentPadding)};
`;
